import config from '../../../config/app.config';
import _get from 'lodash/get';
export const LANGUAGES = [
    { name: 'Deutsch', value: 'de' },
    { name: 'English', value: 'en' }
    // Commented russian lang temporary
    // please uncomment in case if you need it.
    // { name: 'Русский', value: 'ru' }
];
export const LANGUAGES_ITEMS = [
    { label: 'Deutsch', value: 'de', icon: 'new_lang_de' },
    { label: 'English', value: 'en', icon: 'new_lang_en' }
];
export const LOCAL_STORAGE_KEY = {
    JWT_TOKEN_KEY: 'auto_jwt_token',
    JWT_USER_NAME_KEY: 'auto_jwt_username',
    JWT_DISPLAY_NAME_KEY: 'auto_jwt_displayName',
    JWT_IS_ADMIN_KEY: 'auto_jwt_isAdmin',
    i18n_KEY: 'i18nLanguage'
};
export const DEFAULT_LANG = localStorage.getItem(LOCAL_STORAGE_KEY.i18n_KEY) || 'de';
// Default support contact phone
export const CONTACT_PHONE = '+498004030182';
// Key code used across the app
// to handle keyboard enter press event.
export const ENTER_KEY_CODE = 13;
// Firebase error codes. You can see all of them here:
// https://firebase.google.com/docs/reference/js/firebase.auth.Error
export const USER_NOT_FOUND = 'auth/user-not-found';
export const WRONG_PASSWORD = 'auth/wrong-password';
export const USER_DISABLED = 'auth/user-disabled';
// Our internal server error code.
export const API_USER_NOT_FOUND = 'USER_NOT_FOUND';
// Specific images that we show if some car does not have any images in database.
export const PLACEHOLDER_IMAGE_SMALL_URL = `${_get(config, 'imagesAPI.imgUrlBase')}/noimage/small`;
export const PLACEHOLDER_IMAGE_LARGE_URL = `${_get(config, 'imagesAPI.imgUrlBase')}/noimage/large`;
// Promo video of the auto.de. Used on dealer sign-up and dealer edit pages.
export const PROMO_VIDEO_URL = 'https://vimeo.com/306131535/8c0cc19048';
// Links to the Terms of Service pages.
// They are different for the simple customer
// and for the dealer.
export const TOS_USER_URL = '/agb/';
export const TOS_DEALER_URL = '/handler-agb/';
export const DATA_PROCESSING_URL = '/einwilligungserklaerung/';
export const PRIVACY_POLICY_URL = '/datenschutz/';
export const TERMS_AND_USE_URL = '/nutzungsbedingungen/';
// Links to mobile app
export const APPLE_STORE_URL = 'https://itunes.apple.com/us/app/yourapp/id1396544891';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=de.auto.app';
// detailed search keys
export const EMISSION_CLASS_KEY = 'EMISSION_CLASS';
export const EMISSION_STICKER_KEY = 'EMISSION_STICKER';
export const PARTICULATE_FILTER_KEY = 'PARTICULATE_FILTER';
export const GENERAL_INSPECTION_KEY = 'GENERAL_INSPECTION';
export const MONTHS = {
    ru: [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь'
    ],
    en: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ],
    de: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// Custom form validation error messages.
export const CUSTOM_ERROR_MESSAGES = {
    de: {
        required_if: 'Das Feld muss ausgefüllt sein.',
        required_with: 'Das Feld muss ausgefüllt sein.',
        phone: 'Korrektes Format ist +XXXXXXXXXXXX.',
        phone_areaCode: '2 bis 5 Ziffern',
        phone_countryCode: '1 bis 3 Ziffern',
        phone_phoneNumber: '3 bis 12 Ziffern',
        beforeCustomDate: 'Das Datum muss vor der Erstzulassung liegen.',
        'date_dd.mm.yyyy': 'Das gewählte Datum hat nicht das Format dd.mm.yyyy.',
        afterToday: 'Bitte wähle das richtige Datum. (Sollte nach dem aktuellen Datum liegen).',
        vatDeductible: 'Das :attribute ist erforderlich, wenn der Mehrwertsteuersatz ausgewählt ist.',
        required_if_availability_date: 'Bitte geben Sie ein Lieferdatum an.',
        required_if_availability_delivery_period: 'Bitte geben Sie ein Lieferzeitraum an.',
        password: '8 oder mehr Zeichen verwenden.',
        password_strong: 'Mindestens 10 Zeichen, davon eine Ziffer und ein Sonderzeichen.',
        internet_address: 'Bitte geben Sie die gültige Internetadresse ein.',
        iban: 'Bitte geben Sie die gültige IBAN ein.',
        bic: 'Bitte geben Sie die gültige BIC ein.',
        firstName: 'Bitte nur Buchstaben eingeben',
        lastName: 'Bitte nur Buchstaben eingeben',
        email_ascii: 'Bitte verwenden Sie in der E-Mail-Adresse nur lateinische Buchstaben (kein ä, ö, ü, ß etc.)',
        // "7. Ergänzende Regelungen" checkboxes (OrderOverviewNext) — the only 'accepted'-ruled
        // fields sitewide, so this override only ever applies there (Figma 64670:106293).
        accepted: 'Bitte bestätigen Sie diese Vereinbarung, um die Bestellung abzuschließen.',
        // checkout's Geburtsdatum field (ContactInformationNext) — validatorjs's own registered
        // message for this rule is English-only (Validator.ts), so without this override German
        // users saw raw English text once the field started showing its specific error reason.
        'dd/MM/yyyy': 'Bitte geben Sie ein gültiges Geburtsdatum ein (nicht in der Zukunft, mindestens 18 Jahre alt).'
    },
    en: {
        required_if: 'The field is required.',
        required_with: 'The field is required.',
        phone: 'Correct format is +XXXXXXXXXXXX.',
        phone_countryCode: '1 to 3 digits',
        phone_areaCode: '2 to 5 digits',
        phone_phoneNumber: '3 to 12 digits',
        beforeCustomDate: 'Selected date must be before first registration.',
        'date_dd.mm.yyyy': 'Selected date is not in the format dd.mm.yyyy.',
        afterToday: 'Please select correct date. (Should be later than current date).',
        vatDeductible: 'The :attribute field is required if VAT rate selected.',
        required_if_availability_date: 'Please enter a delivery date.',
        required_if_availability_delivery_period: 'Please enter a delivery period.',
        password: 'Use 8 or more characters.',
        password_strong: 'At least 10 characters, including one digit and one special character.',
        internet_address: 'Please enter the valid internet address.',
        iban: 'Please enter the valid IBAN.',
        bic: 'Please enter the valid BIC.',
        firstName: 'Please enter letters only',
        lastName: 'Please enter letters only',
        email_ascii: 'Please use only Latin letters (no ä, ö, ü, ß, etc.) in the email address',
        accepted: 'Please confirm this agreement to complete the order.',
        'dd/MM/yyyy': 'Please enter a valid date of birth (not in the future, at least 18 years old).'
    },
    ru: {
        required_if: 'Поле обязательно для заполнения.',
        required_with: 'Поле обязательно для заполнения.',
        phone: 'Правильный формат +XXXXXXXXXXXX.',
        phone_countryCode: 'от 1 до 3 цифр',
        phone_areaCode: 'от 1 до 5 цифр',
        phone_phoneNumber: 'от 1 до 12 цифр',
        beforeCustomDate: 'Выбранная дата должна быть до первой регистрации.',
        'date_dd.mm.yyyy': 'Выбранная дата не в формате дд.мм.гггг.',
        afterToday: 'Выберите корректную дату. (Она должна быть позже текущей даты).',
        vatDeductible: 'Поле :attribute является обязательным, если выбран курс НДС.',
        required_if_availability_date: 'Поле :attribute является обязательным, если выбрана "доступность по дате".',
        password: 'Используйте 8 или более символов',
        internet_address: 'Пожалуйста, введите действительный интернет-адрес.',
        iban: 'Пожалуйста, введите действительный IBAN.',
        bic: 'Пожалуйста, введите действительный BIC.',
        email_ascii: 'Пожалуйста, используйте в email только латинские буквы (без ä, ö, ü, ß и т.п.)',
        accepted: 'Пожалуйста, подтвердите это соглашение, чтобы завершить заказ.'
    }
};
export const supportEmail = 'auto@auto.de';
export const supportPhone = '0800 - 40 30 182';
export const supportPhoneLink = '+498004030182';
export const ADD_SLIDE_AUTH_TOKEN = 'c2xpZGVyYWRtaW46RUMlb0hKNiN6IWtMOUs5VGhARGR0UTdr';
export const SLIDERADMIN_AUTH_TOKEN = btoa('slideradmin:#q5ESoenvU5@e!09kJ&Hy9M8');
export const TERMS_AND_COND_HEADER = { Authorization: `Basic ${SLIDERADMIN_AUTH_TOKEN}` };
export const BASIC_AUTH_HEADER = { Authorization: `Basic ${btoa('auto:autobrand')}` };
export const HTTP_TO_MANY_REQUESTS = 429;
export const SERVICE_UNAVAILABLE = 503;
export const FORBIDDEN = 403;
/**
 * Cloudflare Managed Challenge detection: the challenge interstitial arrives as a 403 (WAF rules)
 * or a 429 (Rate Limiting rules with a challenge action — confirmed live: same "Just a moment"
 * body/cf-mitigated header as the 403 case, just a different status) whose body is the challenge
 * HTML (the cf-mitigated header is usually not CORS-exposed to JS). A challenged XHR must trigger
 * the same top-level redirect as the 503 path so the browser can actually pass the check —
 * otherwise the user is locked out.
 */
export const isCloudflareChallenge = (response) => {
    if (!response || (response.status !== FORBIDDEN && response.status !== HTTP_TO_MANY_REQUESTS))
        return false;
    const cfMitigated = response.headers && (response.headers['cf-mitigated'] || response.headers['CF-Mitigated']);
    if (cfMitigated)
        return true;
    return typeof response.data === 'string'
        && /cf-browser-verification|challenge-platform|Just a moment|__cf_chl/i.test(response.data);
};
export const ONLINE_SINCE_KEY = 'ONLINE_SINCE';
export const THREE = 3;
export const FOURTEEN = 14; // local storage expiration period (days)
export const HUNDRED = 100;
export const THOUSAND = 1000;
// TODO remove newOffers
export const newOffers = [
    {
        name: 'financing',
        periods: [12, 24, 36, 48, 60, 72, 84, 96], // eslint-disable-line
        sliders: [
            { name: 'firstInstallment', min: 0, step: 100, unit: 'euro' }, // eslint-disable-line
            { name: 'annualMileage', min: 5000, max: 60000, step: 5000, unit: 'km' } // eslint-disable-line
        ]
    },
    {
        name: 'leasing',
        periods: [30, 36, 42, 48, 54, 60], // eslint-disable-line
        sliders: [
            { name: 'firstInstallment', min: 0, step: 100, unit: 'euro' }, // eslint-disable-line
            { name: 'annualMileage', min: 5000, max: 60000, step: 5000, unit: 'km' } // eslint-disable-line
        ]
    },
    { name: 'abo', periods: [1, 2, 6, 9, 12, 18], isActive: false }, // eslint-disable-line
    { name: 'buy' }
];
